import { render, staticRenderFns } from "./PackInfoModal.vue?vue&type=template&id=6470114b&scoped=true&"
import script from "./PackInfoModal.vue?vue&type=script&lang=ts&"
export * from "./PackInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./PackInfoModal.vue?vue&type=style&index=0&id=6470114b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6470114b",
  null
  
)

export default component.exports